<template>

  <v-navigation-drawer
  v-model="drawer"
  fixed
  width="600px"
  right
  class="foreground"
  style="z-index: 9;"
  temporary
  stateless
  >
  <!--
  <v-bottom-sheet
  v-model="drawer"
  inset
  hide-overlay
  scrollable
  >
  -->
    <v-sheet class="foreground" style="display: flex; flex-direction: column; height: 100%;">

      <v-row class="align-center c-flex-00a border-b--thin text background--text pl-2 pr-2 pt-2 pb-2">
        <v-btn
        icon
        class="ml-2"
        @click="drawer = !drawer"
        >
          <v-icon color="background">mdi-chevron-right</v-icon>
        </v-btn>
        <span>
          {{ ( row.definition || {}).name }}
        </span>
        <v-spacer></v-spacer>
      </v-row>
      <v-sheet style="overflow: auto; flex: 1;">
        <!-- MAIN SCROLLING AREA -->
        <v-sheet style="overflow: auto; flex: 1;">
          <div class="text-center pa-3">
            
            <div class="text-uppercase">
              {{ ( row.definition || {}).name }}
            </div>
            <img src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="120px">

            <v-row>
              <v-col sm="6">
                Available
                <div>
                  <c-ms-ii
                  :metric_definition="row.definition"
                  :realValue="totalInventory"
                  :key="(row.definition || {}).id"
                  alwaysScale
                  labelMode
                  class="green--text"
                  ></c-ms-ii>
                </div>
              </v-col>
              <v-col sm="6">
                Total Debits
                <div>
                  <c-ms-ii
                  :metric_definition="row.definition"
                  :realValue="totalDebited"
                  :key="(row.definition || {}).id"
                  alwaysScale
                  labelMode
                  class="color1--text"
                  ></c-ms-ii>
                </div>
              </v-col>
            </v-row>
          </div>


          <v-card class="ma-2">
            <!-- TABLE IN HERE -->
            <table class="final-table th-no-padding lines-b full-width">
              <colgroup ref="colgroup1">
                <col width="15px">
                <col width="15px">
                <col width="15px">
              </colgroup>

              <tr class="unselectable">

                <c-table-header
                title="Code"
                code="code"
                class="sticky"
                :filters="filters"
                @onClick="clickSortHeader">
                </c-table-header>

                <c-table-header
                title="Expiry"
                code="expiry"
                :filters="filters"
                @onClick="clickSortHeader">
                </c-table-header>

                <c-table-header
                title="Quantity"
                code="quantity"
                :filters="filters"
                @onClick="clickSortHeader">
                </c-table-header>

              </tr>
              <tr class="disable-hover">
                <td>
                  <v-text-field
                  v-model="filters.search.id"
                  placeholder="Search..."
                  hide-details
                  class="crx-box-input"
                  clearable
                  color="color1"
                  solo>
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                  v-model="filters.search.id"
                  placeholder="Search..."
                  hide-details
                  class="crx-box-input"
                  clearable
                  color="color1"
                  solo>
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                  v-model="filters.search.id"
                  placeholder="Search..."
                  hide-details
                  class="crx-box-input"
                  clearable
                  color="color1"
                  solo>
                  </v-text-field>
                </td>
                
              </tr>

              <inventory-item-row 
              vmode="table"
              v-for="item in items" 
              :key="item.id"
              :item="item"
              :quantity="(debitMap[item.definition.id] || {})[item.id] || 0"
              :searchFilters="filters.search"
              @onQuantityUpdate="onManualQuantityUpdate(item, ...arguments)"
              @useWholeBatch="useWholeBatch"
              @useNoneOfBatch="useNoneOfBatch"
              ></inventory-item-row>     

            </table>
            <!-- TABLE IN HERE -->
           </v-card>

        </v-sheet>
        <!-- MAIN SCROLLING AREA -->
      </v-sheet>
    </v-sheet>

  </v-navigation-drawer>
</template>

<script>
import Vue from 'vue'
import CTableHeader from '@/components/list-server/th'
import ListController from '@/mixins/ListController'
import InventoryItemRow from './components/inventory-item-row'

export default {
  props: ['inventoryView', 'debitMap'],
  components: {
    InventoryItemRow,
    CTableHeader
  },
  mixins: [ListController],
  data () {
    return {
      drawer: false,
      row: {
      },
      filters: {
        sortCol: 'quantity',
        sortAscending: false,
        search: {
          name: ''
        }
      }
    }
  },
  computed: {
    totalDebited () {
      var debitMap = this.debitMap || {}
      debitMap = debitMap[(this.row.definition || {}).id] || {}
      return Object.values(debitMap).reduce((a,b) => a + b, 0)
    },
    totalInventory () {
      var inventory = this.inventoryView[(this.row.definition || {}).id] || []
      return Object.values(inventory).reduce((a,b) => a + b.quantity, 0)
    }
  },
  methods: {
    useNoneOfBatch (item) {
      // Vue.set(this.debitMap[item.definition.id], item.id, 0)
      Vue.delete(this.debitMap[item.definition.id], item.id)
    },
    useWholeBatch (item) {
      if (!this.debitMap[item.definition.id]) {
        Vue.set(this.debitMap, item.definition.id, {})
      }
      Vue.set(this.debitMap[item.definition.id], item.id, item.quantity)
    },
    onManualQuantityUpdate (item, quantity) {
      if (!this.debitMap[item.definition.id]) {
        Vue.set(this.debitMap, item.definition.id, {})
      }
      Vue.set(this.debitMap[item.definition.id], item.id, quantity)
    },
    open (row) {
      this.drawer = true
      this.row = row
      this.items = Object.values(this.inventoryView[row.definition.id]) || []
    },
    sort (items) {
      console.log('DEBITMAP')
      console.log(JSON.stringify(this.debitMap))
      if (this.filters.sortCol === 'quantity') {
        return items.sort((a, b) => {
          var aQ = ( this.debitMap[a.definition.id] || {})[a.id] || 0
          var bQ = ( this.debitMap[b.definition.id] || {})[b.id] || 0
          return this.filters.sortAscending ? aQ - bQ : bQ - aQ
        })
      } else if (this.filters.sortCol === 'code') {
        return items.sort((a, b) => {
          return this.filters.sortAscending ? a.archive_id - b.archive_id : b.archive_id - a.archive_id
        })
      } else if (this.filters.sortCol === 'expiry') { // Date of entry
        return items.sort((a, b) => {
          return this.filters.sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } /* else if (headerIndex === 3) { // Expiry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (headerIndex === 4) { // Supplier
        return items.sort((a, b) => {
          var supplierA = (this.$store.state.db.suppliers.suppliers[a.supplier_id] || {}).name || ''
          var supplierB = (this.$store.state.db.suppliers.suppliers[b.supplier_id] || {}).name || ''
          return sortAscending ? supplierA.localeCompare(supplierB) : supplierB.localeCompare(supplierA)
        })
      } */
    },
  }
}
</script>